import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IButtonProps {
  isBack?: boolean
  isAdvance?: boolean
  allowNextPage?: boolean
  disabled?: boolean
}

export const ButtonNext = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  border: none;
  background-color: transparent;

  margin-top: 19px;
  width: ${(props: IButtonProps) => {
    if (props.isBack && props.isAdvance) return '200px'
    return '120px'
  }};

  gap: 14px;

  margin-top: 19px;
  height: 40px;

  color: ${Theme.pallete.PRIMARY};
  font-family: ${Theme.fontFamily.PRIMARY};

  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.75px;
  text-align: center;

  .btn-next-icon {
    width: 19px;

    height: 19px;
    cursor: pointer;
    filter: invert(100%) brightness(100%);
    @media only screen and (min-width: 1441px) {
      width: 21px;
      height: 21px;
    }
  }

  .btn-circle {
    background-color: black;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    outline: none;

    @media only screen and (min-width: 1441px) {
      width: 45px;
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  @media only screen and (min-width: 1441px) {
    height: 45px;
    width: ${(props: IButtonProps) => {
      if (props.isBack && props.isAdvance) return '207px'
      return '126px'
    }};
    font-size: 13px;
    gap: 12px;
  }
`
